import React, { useState, useEffect } from "react";
import PhoneInput from "../Login/utils/PhoneInput";
import { authAPI, handleApiError } from "../../../services/api";
import OtpInput from "../Login/utils/OtpInput";
import { validateRegisterForm, validateOtp, validatePassword } from "../../Auth/Login/utils/validate";

import { useTranslation } from "react-i18next";

const Register = ({ onRegister, onSwitchToLogin, loading = false, startParam }) => {
  const { t, i18n} = useTranslation("auth");
  const { t: tv } = useTranslation("validate"); // для валидаций

  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    phone: "",
    password: "",
    confirmPassword: "",
    otp: "",
    referrer: startParam['ref'] ?? "",
    agreement: false,
    isadult: false,
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [agreementId, setAgreementId] = useState("terms_v1.0");
  const [agreementLoading, setAgreementLoading] = useState(true);
  
  // ✅ Добавляем состояние для попыток OTP (как в Login)
  const [triesLeft, setTriesLeft] = useState(null);

  // ✅ новые состояния
  const [agreementData, setAgreementData] = useState(null);
  const [showAgreementModal, setShowAgreementModal] = useState(false);

  useEffect(() => {
    const fetchAgreement = async () => {
      try {
        setAgreementLoading(true);
        const response = await authAPI.getCurrentAgreement();
        console.log("Получено соглашение:", response.data);
        if (response.data) {
          setAgreementId(response.data.id);
          setAgreementData(response.data);
        }
      } catch (error) {
        console.error("Ошибка получения соглашения:", error);
        setErrors({ general: error?.response?.data?.error })
      } finally {
        setAgreementLoading(false);
      }
    };

    fetchAgreement();
  }, []);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  const handleRequestOtp = async (e) => {
    e.preventDefault();
    const errs = validateRegisterForm(formData, tv)
    setErrors(errs)

    if (!(Object.keys(errs).length === 0)) return;

    setIsSubmitting(true);
    setErrors({});

    try {
      const phoneDigits = formData.phone.replace(/\D/g, "");
      
      const response = await authAPI.makeRegisterInit(phoneDigits);

      if (response.data && response.data.sended) {
        setOtpSent(true);
        setStep(2);
        setTriesLeft(null); // ✅ Сбрасываем счетчик попыток при новом запросе

        setTimeout(() => {
          document.getElementById("otp-input")?.focus();
        }, 100);
      } else {
        setErrors({ general: t("CANT_SEND_VALIDATION_CODE") });
      }
    } catch (error) {
      console.error("Ошибка запроса OTP:", error);
      setErrors({ general: error?.response?.data?.error });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSubmit = async (e) => {
    if (e && e.preventDefault) e.preventDefault();

    const errs = validateOtp(formData.otp, tv)
    setErrors(errs)

    if (!Object.keys(errs).length === 0) return;

    console.log("Используем agreement_id для регистрации:", agreementId);

    setIsSubmitting(true);
    setErrors({});

    try {
      const phoneDigits = formData.phone.replace(/\D/g, "");
      const registrationData = {
        phone: phoneDigits,
        password: formData.password,
        otp: parseInt(formData.otp),
        agreement_id: agreementId,
        lang: "ru",
      };

      if (formData.promo && formData.promo.trim()) {
        registrationData.promo = formData.promo.trim();
      }

      if (formData.referrer && formData.referrer.trim()) {
        registrationData.referrer = formData.referrer.trim();
      }

      console.log("Отправляем данные регистрации:", registrationData);
      const response = await authAPI.makeRegisterConfirm(registrationData, i18n.language);

      console.log("Ответ сервера регистрации:", response.data);

      // ✅ Проверяем результат регистрации
      if (response.data.is_registered === true) {
        if (onRegister) onRegister(response.data);
      } else if (response.data.is_registered === false) {
        // ✅ Обрабатываем неправильный OTP (как в Login)
        const tries = response.data.tries_available;
        setTriesLeft(tries);
        
        if (tries > 0) {
          setErrors({ 
            otp: `${t("OTP_TRY_LEFT")}: ${tries}` 
          });
        } else {
          setErrors({ 
            otp: t("OTP_TRY_OUT")
          });
        }
      }

    } catch (error) {
      console.error("Ошибка регистрации:", error);
      
      // ✅ Проверяем, есть ли информация о попытках в ошибке
      if (error?.response && error?.response?.data) {
        const errorData = error.response.data;

        if (errorData.is_registered === false && errorData.tries_available !== undefined) {
          const tries = errorData.tries_available;
          setTriesLeft(tries);
          
          if (tries > 0) {
            setErrors({ 
              otp: `${t("OTP_TRY_LEFT")}: ${tries}` 
            });
          } else {
            setErrors({ 
              otp: t("OTP_TRY_OUT")
            });
          }
          return; // Не показываем общую ошибку
        }
      }
      // Для других ошибок показываем общее сообщение
      const errorMessage = error?.response?.data?.error;
      setErrors({ general: errorMessage });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleBackToStep1 = () => {
    setStep(1);
    setErrors({});
    setTriesLeft(null); // ✅ Сбрасываем счетчик попыток
    setFormData((prev) => ({ ...prev, otp: "" }));
  };

  const handleResendOtp = async () => {
    setIsSubmitting(true);
    try {
      const phoneDigits = formData.phone.replace(/\D/g, "");
      
      const response = await authAPI.makeRegisterInit(phoneDigits);
      
      if (response.data && response.data.sended) {
        setErrors({});
        setTriesLeft(null); // ✅ Сбрасываем счетчик попыток при новом коде
        setFormData(prev => ({ ...prev, otp: '' })); // ✅ Очищаем поле OTP
        console.log("Код повторно отправлен");
      } else {
        setErrors({ general: t("CAND_RESEND_OTP") });
      }
    } catch (error) {
      console.error("Ошибка повторной отправки OTP:", error);
      setErrors({ general: error?.response?.data?.error });
    } finally {
      setIsSubmitting(false);
    }
  };

  // === Шаг 1 ===
  if (step === 1) {
    return (
      <div className="min-h-screen flex flex-col bg-white">
        <div className="flex flex-1 flex-col justify-center px-4 py-1">
          <div className="w-full max-w-md mx-auto bg-white rounded-2xl shadow-md p-4">
            <div className="text-center mb-4">
              <h1 className="text-2xl font-bold text-gray-900">{t("REGISTRATION")}</h1>
              <p className="text-gray-500 mt-2">{t("CREATE_ACCOUNT_IN")}</p>
            </div>

            {errors.general && (
              <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-xl">
                <span className="text-red-700 text-sm">{errors.general}</span>
              </div>
            )}

            <form onSubmit={handleRequestOtp} className="flex flex-col gap-4">
              <PhoneInput
                value={formData.phone}
                onChange={(val) => handleInputChange("phone", val)}
                error={errors.phone}
                disabled={isSubmitting}
              />

              <input
                type="password"
                placeholder={t("PASSWORD")}
                value={formData.password}
                onChange={(e) => handleInputChange("password", e.target.value)}
                disabled={isSubmitting}
                className="w-full border-2 rounded-xl px-4 py-3 text-sm !text-black"
              />
              {errors.password && (
                <span className="text-red-500 text-sm">{errors.password}</span>
              )}

              <input
                type="password"
                placeholder={t("CONFIRM_PASSWORD")}
                value={formData.confirmPassword}
                onChange={(e) =>
                  handleInputChange("confirmPassword", e.target.value)
                }
                disabled={isSubmitting}
                className="w-full border-2 rounded-xl px-4 py-3 text-sm !text-black"
              />
              {errors.confirmPassword && (
                <span className="text-red-500 text-sm">
                  {errors.confirmPassword}
                </span>
              )}

              <input
                type="text"
                placeholder={t("PROMO_PLACEHOLDER")}
                value={formData.promo}
                onChange={(e) => handleInputChange("promo", e.target.value)}
                disabled={isSubmitting}
                className="w-full border-2 rounded-xl px-4 py-3 text-sm !text-black"
              />

              {/* Чекбокс с модалкой */}
              <div className="flex items-start gap-1">
                <input
                  type="checkbox"
                  id="agreement"
                  checked={formData.agreement}
                  onChange={(e) =>
                    handleInputChange("agreement", e.target.checked)
                  }
                  disabled={isSubmitting}
                  className="appearance-auto accent-blue-500 mt-1"
                />
                <label htmlFor="agreement" className="text-sm text-gray-600">
                  {t("IM_AGREE_WITH")}{" "}
                  <button
                    type="button"
                    onClick={() => setShowAgreementModal(true)}
                    className="text-blue-500 underline"
                  >
                    {t("USAGE_CONDITION")}
                  </button>
                  {" "}и{" "}
                  <button
                    type="button"
                    onClick={() => console.log("Открыть политику")}
                    className="text-blue-500 underline"
                  >
                    {t("PRIVACY_POLICY")}
                  </button>
                </label>
              </div>
                {errors.agreement && (
                  <span className="text-red-500">{errors.agreement}</span>
                )}
              <div className="flex items-center gap-2">
                <input
                  type="checkbox"
                  id="isadult"
                  checked={formData.isadult}
                  onChange={(e) => handleInputChange("isadult", e.target.checked)}
                  disabled={isSubmitting}
                  className="appearance-auto accent-blue-500"
                />
                <label htmlFor="isadult" className="text-sm text-gray-600">
                  {t("AGREE_ADULT")}
                </label>
              </div>

                {errors.isadult && (
                  <span className="text-red-500 text-sm">{errors.isadult}</span>
                )}
              <button
                type="submit"
                className="w-full bg-blue-500 text-white py-3 rounded-xl disabled:opacity-70 disabled:cursor-not-allowed"
                disabled={isSubmitting || agreementLoading}
              >
                {isSubmitting
                  ? t("SENDING_SMS") + "..."
                  : agreementLoading
                  ? t("LOADING") + "..."
                  : t("GET_CODE")}
              </button>
            </form>

            <div className="text-center mt-6">
              <button
                onClick={onSwitchToLogin}
                className="text-blue-500 hover:text-blue-600"
                disabled={isSubmitting}
              >
                {t("HAVE_ACCOUNT")}
              </button>
            </div>
          </div>
        </div>

        {/* Модалка соглашения */}
        {showAgreementModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white p-6 rounded-2xl shadow-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto mx-4">
              <h2 className="text-xl font-bold mb-4">
                {agreementData?.name || t("USER_EULA")}
              </h2>
              <p className="text-sm text-gray-500 mb-4">
                {t("DATE")}: {agreementData?.date || "—"}
              </p>
              <div
                className="text-gray-700 prose max-w-none"
                dangerouslySetInnerHTML={{
                  __html:
                    agreementData?.content ||
                    `<p>${t("EULA_NOT_NOW")}</p>`,
                }}
              />
              <div className="mt-6 flex justify-end gap-3">
                <button
                  onClick={() => setShowAgreementModal(false)}
                  className="px-4 py-2 rounded-xl bg-gray-200 hover:bg-gray-300 transition"
                >
                  {t("CLOSE")}
                </button>
                <button
                  onClick={() => {
                    handleInputChange("agreement", true);
                    setShowAgreementModal(false);
                  }}
                  className="px-4 py-2 rounded-xl bg-blue-500 text-white hover:bg-blue-600 transition"
                >
                  {t("AGREE")}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  // === Шаг 2 ===
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <div className="flex flex-1 flex-col justify-center px-6 py-12">
        <div className="w-full max-w-md mx-auto bg-white rounded-2xl shadow-md p-8">
          <div className="text-center mb-8">
            <h1 className="text-2xl font-bold text-gray-900">{t("CONFIRMATION")}</h1>
            <p className="text-gray-500">
              {t("ENTER_CODE_SENDED")} <br />
              <span className="font-semibold">{formData.phone}</span>
            </p>
          </div>

          {errors.general && (
            <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-xl">
              <span className="text-red-700 text-sm">{errors.general}</span>
            </div>
          )}

          <form onSubmit={handleSubmit} className="flex flex-col gap-6">
            <OtpInput
              value={formData.otp}
              onChange={(value) => handleInputChange("otp", value)}
              error={errors.otp}
              disabled={isSubmitting}
            />
            
            <button
              type="submit"
              className="w-full bg-blue-500 text-white py-3 rounded-xl font-semibold disabled:opacity-70 disabled:cursor-not-allowed hover:bg-blue-600 transition"
              disabled={isSubmitting || triesLeft === 0} // ✅ Блокируем кнопку если попытки закончились
            >
              {isSubmitting ? (
                <div className="flex items-center justify-center gap-3">
                  <div className="w-5 h-5 border-2 border-transparent border-t-white rounded-full animate-spin"></div>
                   {t("REGISTRATION")}...
                </div>
              ) : (
                t("END_REGISTRATION")
              )}
            </button>
          </form>

          <div className="flex justify-between mt-6 text-sm">
            <button
              onClick={handleBackToStep1}
              className="text-gray-500 hover:text-gray-700 disabled:opacity-50"
              disabled={isSubmitting}
            >
              ← {t("BACK")}
            </button>
            
            {/* ✅ Показываем кнопку повторной отправки только если попытки закончились или обычное переотправка */}
            {triesLeft === 0 ? (
              <button
                onClick={handleResendOtp}
                className="text-blue-500 hover:text-blue-600 disabled:opacity-50"
                disabled={isSubmitting}
              >
                {isSubmitting ? `${t("SENDING")}...` : t("ASK_NEW_CODE")}
              </button>
            ) : (
              <button
                onClick={handleResendOtp}
                className="text-blue-500 hover:text-blue-600 disabled:opacity-50"
                disabled={isSubmitting}
              >
                {isSubmitting ? `${t("SENDING")}...` : `↻ ${t("RESEND")}`}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;